import React from 'react'
import styled from 'styled-components'
import Amort from '../finwhale/amort/'
import * as media from '../media'
import Princip from '../finwhale/common/princip'
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const Header = styled.div`
  margin-top: 40px;
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const Description = styled.div`
  display: flex;
  margin-top: 40px;
  ${media.smallerThan(900)` flex-direction: column-reverse; align-items: center;`}
  ${media.smallerThan(700)`text-align: center;`}
`

const A = styled.a`
  ${props => props.active
  ? 'background: #0054ff; color: #fff; cursor: auto;'
  : 'cursor: pointer; background: #fff; color: #0054ff; span { border-bottom: 1px dashed; } &:hover { color: red; }'
  }
  padding: 26px 34px;
  padding-left: 0;
  padding-right: 0;
  text-decoration: none;
  display: inline-block;
  transition: all .3s ease;
  color: #173DB0;
`

const ProtectionContainer = styled.div`
  font-size: 22px;
  margin-top: 40px;
  margin-bottom: 20px;
  font-weight: 800;
  ${media.smallerThan(700)` text-align: center;`}
`

const Container = styled.div`

  ${media.smallerThan(700)` text-align: center;`}
`

const page = () => (
  <CurrentLanguageContext.Consumer>
    {currentLanguage => {
      return (

        <div>
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <div style={{width: '80%'}}>
              <div style={{margin: '0 auto', fontSize: '18px'}}>
                <Header>
                  <TranslateText id={"about__header"} />
                </Header>
                <Description>
                  <div
                    style={{
                      flexGrow: 1,
                      flexShrink: 1,
                    }}
                  >
                    <TranslateText id="about__text" useHtml />
                    <A href={currentLanguage === 'en' ? 'mailto:info@finwhale.eu' : 'mailto:postavka@finwhale.ru'}>
                      <TranslateText id="about__question" />
                    </A>
                  </div>
                </Description>

                <Princip/>

                <ProtectionContainer>
                  <TranslateText id="main__protection_header" />
                </ProtectionContainer>

                <Container style={{fontSize: '18px'}}>
                  <TranslateText id="main__protection" useHtml />
                  <div style={{marginTop: 40, marginBottom: 20}}>
                    <Amort/>
                  </div>
                  
                </Container>
              </div>
            </div>
          </div>
        </div>
      );
    }}
  </CurrentLanguageContext.Consumer>
)


export default page


// WEBPACK FOOTER //
// ./src/pages/about.js